import { render, staticRenderFns } from "./ClubUserProfile.vue?vue&type=template&id=565264a8"
import script from "./ClubUserProfile.vue?vue&type=script&lang=js"
export * from "./ClubUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports